export const STEPS = {
  UPLOAD: "Upload",
  PROCESSING: "Processing",
  REVIEW: "Review",
  COMPLETE: "Complete",
};

export const STEP_LABELS = ["Upload", "Processing", "Review", "Complete"];
